import i18n from 'i18n';
import { appToast } from 'utils/toast.utils';

const ksefErrors: Record<
  string,
  { severity: 'info' | 'warning' | 'error'; showDetails?: boolean }
> = {
  KsefInvoicePublicationInProgress: { severity: 'info' },
  KsefInvoiceTransmissionInProgress: { severity: 'warning' },
  KsefInvoiceManualReviewRequired: { severity: 'error' },
  KsefFa3SchemaValidation: { severity: 'error', showDetails: true },
  KsefInvoiceBusinessValidation: { severity: 'error', showDetails: true },
  KsefZeroVatForForeignBuyer: { severity: 'error' },
  KsefInvoiceRejected: { severity: 'error', showDetails: true },
  KsefInvoicePublicationTechnicalFailure: { severity: 'error' },
  KsefInvoicePublicationFailed: { severity: 'error' },
  BaseInvoiceMissingKsefNumber: { severity: 'error' },
  KsefQrLinkMissingForPrint: { severity: 'warning' },
};

export const showKsefErrorToast = (
  message: string | null,
  details: string | null,
): boolean => {
  if (!message || !Object.prototype.hasOwnProperty.call(ksefErrors, message)) {
    return false;
  }

  const { severity, showDetails } = ksefErrors[message];
  appToast[severity](
    i18n.t<string>(`ksefErrors.${message}`, { ns: 'invoice' }),
    showDetails && details
      ? i18n.t<string>('ksefErrorDetails', { ns: 'invoice', details })
      : undefined,
    { position: 'top-right', autoClose: 8000 },
  );
  return true;
};
